// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3XI14","inner":"Form_inner__2CWQB","range":"Form_range__2UivF","name":"Form_name__3gAFs","actions":"Form_actions__3OINL"};